import React, { useState } from 'react'
import styled from '@emotion/styled'
import { useNavigate } from 'react-router-dom'
import { usePortalAuth } from '../hooks/usePortalAuth'

const LogoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
  background: #f9fafb;
`

const LogoutCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 400px;
  padding: 32px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
`

const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #111827;
  margin: 0;
  text-align: center;
`

const Description = styled.p`
  font-size: 16px;
  color: #4b5563;
  margin: 0;
  text-align: center;
`

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 8px;
`

const LogoutButton = styled.button`
  flex: 1;
  padding: 14px 24px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  background: #ef4444;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover:not(:disabled) {
    background: #dc2626;
  }

  &:disabled {
    background: #4a4a4a;
    cursor: not-allowed;
  }
`

const CancelButton = styled.button`
  flex: 1;
  padding: 14px 24px;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: rgba(var(--portal-primary-rgb, 124, 58, 237), 0.08);
    border-color: var(--portal-primary, #7c3aed);
    color: var(--portal-primary, #7c3aed);
  }
`

export const PortalLogoutPage: React.FC = () => {
  const [isLoggingOut, setIsLoggingOut] = useState(false)
  const { logout } = usePortalAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    setIsLoggingOut(true)
    try {
      await logout()
      navigate('/portal/login', { replace: true })
    } catch (error) {
      console.error('Logout error:', error)
      setIsLoggingOut(false)
    }
  }

  const handleCancel = () => {
    navigate('/portal')
  }

  return (
    <LogoutContainer>
      <LogoutCard>
        <Title>Log out</Title>
        <Description>Are you sure you want to log out of your portal?</Description>
        <ButtonGroup>
          <CancelButton onClick={handleCancel}>Cancel</CancelButton>
          <LogoutButton onClick={handleLogout} disabled={isLoggingOut}>
            {isLoggingOut ? 'Logging out...' : 'Log out'}
          </LogoutButton>
        </ButtonGroup>
      </LogoutCard>
    </LogoutContainer>
  )
}
